import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[uiToastError]',
})
export class UiToastErrorDirective {
  constructor() {}
  @HostBinding('class') elClass = 'error';
}
